import { render, staticRenderFns } from "./ConsultaAcoes.vue?vue&type=template&id=6688c0f4&scoped=true&"
import script from "./ConsultaAcoes.vue?vue&type=script&lang=js&"
export * from "./ConsultaAcoes.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaAcoes.vue?vue&type=style&index=0&id=6688c0f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6688c0f4",
  null
  
)

export default component.exports